import { Invite, Invites } from '../stores/types';
import { Invitee, InviteResponse } from '../stores/types/invites.interface';
import { Api, API_KEYS } from './base.api';

export const inviteApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    fetchDelegationInvites: builder.query<Invite[], void>({
      query: () => ({
        url: `/internal/core/v2/${API_KEYS.DELEGATION_INVITES}?self=true&filter_eq[status]=Pending`,
        method: 'GET',
      }),
      providesTags: () => [{ type: API_KEYS.DELEGATION_INVITES, id: 'LIST' }],
    }),
    sendDelegationInvites: builder.mutation<
      InviteResponse[],
      { companyId: string; invitees: Invitee[] }
    >({
      query: (payload) => ({
        url: `/internal/core/v2/${API_KEYS.DELEGATION_INVITES}`,
        body: payload,
        method: 'POST',
        toast: {
          successTrans: 'successfull_invited',
          values: {
            users: payload.invitees.length,
            companies: 1,
          },
        },
      }),
      invalidatesTags: () => [{ type: API_KEYS.DELEGATION_INVITES, id: 'LIST' }],
    }),
    deleteDelegationInvites: builder.mutation<any, Invites>({
      query: (payload) => ({
        url: `/internal/core/v2/${API_KEYS.DELEGATION_INVITES}?self=true`,
        body: payload,
        method: 'DELETE',
      }),
      invalidatesTags: () => [{ type: API_KEYS.DELEGATION_INVITES, id: 'LIST' }],
    }),
    updateDelegationInvites: builder.mutation<any, Invites>({
      query: (payload) => ({
        url: `/internal/core/v2/${API_KEYS.DELEGATION_INVITES}:accept`,
        body: payload,
        method: 'PATCH',
        toast: {
          successTrans: 'successfull_joined',
          values: {
            companies: payload.inviteIds?.length,
          },
        },
      }),
      invalidatesTags: () => [
        { type: API_KEYS.DELEGATION_INVITES, id: 'LIST' },
        { type: API_KEYS.COMPANIES },
      ],
    }),
  }),
});

export const {
  useFetchDelegationInvitesQuery,
  useSendDelegationInvitesMutation,
  useUpdateDelegationInvitesMutation,
  useDeleteDelegationInvitesMutation,
} = inviteApi;
